import { Offer } from "@origin-digital/features";

export const getMboxSlug = (routeParams: Record<string, string>) => {
  const keys = Object.keys(routeParams);

  const { category, articleName, articleId } = routeParams;
  if (keys.length === 0) {
    return "help-support"; // base path
  } else if (category && !(articleName || articleId)) {
    return category; // category or subcategory path
  }

  return null;
};

export const getAppMode = (isNative: boolean) => (isNative ? "app" : "web");

export const getPrimaryMboxes = (isNative: boolean) => {
  const mode = getAppMode(isNative);
  return [`hs-primary-${mode}-1`, `hs-primary-${mode}-2`];
};

export const getSecondaryMboxes = (slug: string, isNative: boolean) => {
  const mode = getAppMode(isNative);
  return [`hs-secondary-${slug}-${mode}-1`, `hs-secondary-${slug}-${mode}-2`];
};

export const getOffers = (targetOffers: Offer[], mboxes: string[]) => {
  const mboxOffers = targetOffers.filter(
    (offer) => mboxes.indexOf(offer.mbox) > -1
  );
  return mboxOffers.reduce((contentArray: any[], targetOffer: Offer) => {
    const content = targetOffer.content || [];
    return [...contentArray, ...content];
  }, []);
};

export const capitaliseFirstName = (name: string | null | undefined) => {
  if (!name) {
    return "";
  }

  const normalised = name.trim().toLocaleLowerCase().split("");
  return normalised.reduce((acc: string, letter: string, index: number) => {
    const lastLetter = acc[acc.length - 1];
    if (index === 0 || ["-", " "].indexOf(lastLetter) > -1) {
      return acc + letter.toUpperCase();
    } else {
      return acc + letter;
    }
  }, "");
};
